/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Joor_Change_PendingInputs */

const en_so_joor_change_pending = /** @type {(inputs: So_Joor_Change_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change from Joor waiting`)
};

/**
* | output |
* | --- |
* | "Change from Joor waiting" |
*
* @param {So_Joor_Change_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_joor_change_pending = /** @type {((inputs?: So_Joor_Change_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Joor_Change_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_joor_change_pending(inputs)
});